import { VisionNumberFormatType, VisionPercentFormatType } from '../enums';
import { getCookieLocalizationSettings } from './storage.utils';

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  const formatter = new Intl.NumberFormat(getCookieLocalizationNumberFormatter(), options);

  return formatter.format(value);
}

export function getCookieLocalizationNumberFormatter(): 'en-US' | 'tr-TR' {
  const localizationSettings = getCookieLocalizationSettings();
  return localizationSettings?.number_format === VisionNumberFormatType.COMMA ? 'en-US' : 'tr-TR';
}

export function getCookieLocalizationPercentFormat(): VisionPercentFormatType {
  const localizationSettings = getCookieLocalizationSettings();
  return localizationSettings?.percent_format;
}

// gelen değeri  const percentFormat = getCookieLocalizationPercentFormat(); baktıktan sonra sağına soluna % ekleyip döndür
export function isValidNumber(value: unknown): value is number {
  return typeof value === 'number' && !Number.isNaN(value);
}

export function formatPercent(value: number, options?: Intl.NumberFormatOptions): string {
  const percentFormat = getCookieLocalizationPercentFormat();
  const formatter = new Intl.NumberFormat(getCookieLocalizationNumberFormatter(), options);
  const formattedValue = formatter.format(value);

  if (percentFormat === VisionPercentFormatType.COMMA_LEFT) {
    return `%${formattedValue}`;
  }

  return `${formattedValue}%`;
}
